import { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import './HamburgerMenu.css';

function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsOpen(false);
    }
  };

  return (
    <>
      <button
        className="hamburger-button"
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isOpen}
      >
        {isOpen ? FaTimes({}) : FaBars({})}
      </button>

      <nav className={`hamburger-nav ${isOpen ? 'open' : ''}`}>
        <ul className="nav-list">
          <li>
            <button onClick={() => scrollToSection('hero-section')} className="nav-link">
              Home
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('about-section')} className="nav-link">
              About Me
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('skills-section')} className="nav-link">
              Skills
            </button>
          </li>
        </ul>
      </nav>

      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
    </>
  );
}

export default HamburgerMenu;
